import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Row, Col, Button, Offcanvas, Image, Form, InputGroup } from 'react-bootstrap';
import transaction from "../../actions/transaction";
import auth from "../../actions/auth";
import dayjs from 'dayjs';
import { toast } from 'react-toastify';

import {ReactComponent as QuestionSvg} from './../../assets/icons/svg/question.svg';
import {ReactComponent as MitraSvg} from './../../assets/icons/svg/mitra.svg';


export default function TrashAdd() {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [auths, setAuths] = useState([]);
  const [partner, setPartner] = useState([]);
  const [pickMitra, setPickMitra] = useState(null);
  const [imagePicked, setImagePicked] = useState(null);
  const [form, setForm] = useState({
      partner_id: '',
      phone: '',
      image: '',
      weight: '',
      weight_unit: 'Kg'
   });
   const [showResp, setShowResp] = useState(false);
   const [showConfirm, setShowConfirm] = useState(false);
   const [showImage, setShowImage] = useState('');
   const handleCloseResp = () => setShowResp(false);
   const handleShowResp = () => setShowResp(true);
   const handleCloseConfirm = () => setShowConfirm(false);
   const handleShowConfirm = () => setShowConfirm(true);
   const [loading, setLoading] = useState(false);

  useEffect(() => {
   auth.actions.get_users().then((res)=>{
      setAuths(res?.data);
   })
   transaction.actions.get_partner().then((res)=>{
      setPartner(res?.data?.data);
   })
  },[])

  const handleClickFile = (e) => {
   e.preventDefault()
   inputRef.current.click()
  }

  const handleUploadFile = (e) => {
   var file = e.target.files[0];
   setImagePicked(file);
   setShowImage(URL.createObjectURL(file));
  }

  const handleSubmit = (e) => {
   setLoading(true)
   e.preventDefault();
   const formData = new FormData();
   console.log(imagePicked)
   formData.append("image", imagePicked);
   formData.append("weight", form.weight);
   formData.append("weight_unit", form.weight_unit);
   formData.append("phone", form.phone);
   formData.append("partner_id", pickMitra?.id);
   transaction.actions.post_pickup(formData).then((res)=>{
      toast.success(res.data);
      navigate(-1)
      setLoading(false)
   }).catch((err) => {
      toast.error(err.message);
      setLoading(false)
   })
  }

  const contactAdmin = () => {
   var phones = pickMitra.phone
   if(phones[0] === '0'){
      phones = '+62' + phones.substring(1);
   }else{
      phones = pickMitra.phone
   }
   window.open(`https://wa.me/${phones}/?text=Halo ${pickMitra?.name}`, '_blank')
  }
  

  return (
   <Form>
      <div className="fixed-top header bg-gray">
         <div className="text-center fw-semibold">
            Form Permintaan Jemput
         </div>
         <Button className="btn btn-icon btn-success btn-sm btn-radius btn-nav-back" onClick={() => navigate(-1)}>
               <i className="ph-arrow-left text-light"></i>
         </Button>
      </div>
      
      <div className="px-4 content-height pt-5 mt-5 bg-gray">
         <div className="d-flex mb-4 mt-4 align-items-center justify-content-between px-1" onClick={() => handleShowResp()}>
            <div className="d-flex align-items-center">
               <div className="icon-fill-based me-4">
                  {pickMitra ? 
                     <Image src={pickMitra?.avatar} className="br-avatar" width="50px" height="50px"/> :
                     <MitraSvg/>            
                  }
               </div>
               <div className="selected">
                  <h6 className="fw-bold mb-1">{pickMitra ? <span>{pickMitra?.name}</span> : <span>Pilih Mitra</span> }</h6>
                  {pickMitra ? 
                     <div className="text-success ts-sm">Terdaftar</div> :
                     <div className="text-danger ts-sm">Belum ada BSU/Mitra dipilih</div>
                  }
                  </div>
            </div>
            <div>
               <i className="ph-caret-down fw-bold"></i>
            </div>
         </div>

         <Row className="px-2 mb-3">
            <Col xs={5} className="text-muted">
               ID Nasabah
            </Col>
            <Col xs={7} className="text-muted">
               {dayjs(auths?.created_at).format('DD/MMMM YYYY')} <span className="ms-2 text-muted">{auths?.name}</span>
            </Col>
         </Row>
         <Row className="px-2 mb-4">
            <Col xs={5} className="text-muted">
               Alamat
            </Col>
            <Col xs={7} className="text-muted wrap-in">
               {auths?.address}{', '}
               {auths?.village?.name}{', '}
               {auths?.district?.name}{', '}
               {auths?.province?.name}{', '}
               {auths?.cities?.name}
            </Col>
         </Row>
         <hr />
         <Form.Group className="mb-4 mt-4">
            <Form.Label className="mb-2">No.Handphone (WhatsApp)*</Form.Label>
            <Form.Control type="text" placeholder="No. Handphone" className="px-3" defaultValue={form.weight} onChange={(e) => setForm({...form, ...{phone: e.target.value}})}/>
         </Form.Group>
         <Form.Group className="mb-4">
            <Form.Label className="mb-2">Estimasi Berat Sampah*</Form.Label>
            <InputGroup className="mb-3">
               <Form.Select className="form-group-left w-25 px-3" defaultValue={form.weight_unit} onChange={(e) => setForm({...form, ...{weight_unit: e.target.value}})}>
                  <option value="Kg">Kg</option>
                  <option value="Ton">Ton</option>
               </Form.Select>
               <Form.Control type="number" className="form-group-right w-75" placeholder="Berat sampah"
                  defaultValue={form.weight} onChange={(e) => setForm({...form, ...{weight: e.target.value}})}
               />
            </InputGroup>
         </Form.Group>
         <Form.Group className="mb-4">
            <Form.Text className="mb-2 w-100">
               <div className="d-flex justify-content-between">
                  <h6 className="pt-2 form- mb-0">Foto Sampah*</h6>
                  <div>
                     {showImage === '' ?
                        <button 
                           type="button"
                           className="btn btn-sm btn-success rounded-pill py-2 d-flex align-items-center justify-content-center" 
                           onClick={handleClickFile}
                        >
                           <i className="ph-camera me-2 text-light"></i> Ambil Foto Sampah
                        </button> :
                        <div className="image-prev">
                           <Image src={showImage} className="img-thumb"/>
                           <button className="img-x btn btn-sm" onClick={(e) => {setImagePicked(null), setShowImage('')}}>
                              <i className="ph-x"></i>
                           </button>
                        </div>
                     
                     }
                  </div>
                     <input
                        ref={inputRef}
                        type="file"
                        className="d-none"
                        onChange={(e) => handleUploadFile(e)}
                        accept="image/*"
                        onClick={(event)=> { 
                           event.target.value = null
                        }}
                     />
               </div>
            </Form.Text>
         </Form.Group>
         <div className="text-center mt-5">
            <small className="text-muted ts-sm">
               Hubungi Kontak WhatsApp Kami jika mengalami kendala atau kesulitan dalam pengisian data.
            </small>
         </div>
      </div>
      <div className="btn-fixed-btm">
         <div className="d-flex justify-content-between align-items-center w-100 px-4">
            <Button type="button" onClick={() => contactAdmin()} disabled={!pickMitra} className="rounded-pill py-2 me-3 w-50 d-flex align-items-center justify-content-center" variant="success-opacity">
               <i className="ph-whatsapp-logo me-2 text-success"></i> Kontak Kami
            </Button>
            <Button type="button" onClick={() => handleShowConfirm()} className="rounded-pill py-2 w-50" variant="success">
               Kirim
            </Button>
         </div>
      </div>


      <Offcanvas show={showResp} onHide={handleCloseResp} placement="bottom" className="h-auto">
         <Offcanvas.Header closeButton>
            <Offcanvas.Title>Pilih Mitra</Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body className="p-0">
            {partner.length && partner.map((item, key)=> {
               return(
                  <div className="p-3 border-bottom" key={key} onClick={() => {setPickMitra(item);handleCloseResp()}}>
                     <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                           <Image src={item.avatar} className="br-avatar me-3" width="50px" height="50px"/>
                           <div className="selected">
                              <h6 className="fw-bold mb-1">{item.name}</h6>
                              <small className="text-success">Terdaftar</small>
                           </div>
                        </div>
                        <div>
                           <i className="ph-caret-right fw-bold"></i>
                        </div>
                     </div>
                  </div>
                  )
            })
            }
         </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={showConfirm} onHide={handleCloseConfirm} placement="bottom" className="h-auto">
         <Offcanvas.Header closeButton>
            <Offcanvas.Title></Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body className="py-5">
            <div className="my-3 text-center">
               <QuestionSvg/>
            </div>
            <div className="my-5">
               <div className="text-center text-body">
                  Apakah Anda yakin ingin mengirimkan data permintaan jemput & data sudah sesuai?
               </div>
            </div>

            <div className="d-flex justify-content-between align-items-center w-100 px-4">
               <Button disabled={loading} type="button" className="rounded-pill py-2 me-3 w-50 d-flex align-items-center justify-content-center" variant="success-opacity" onClick={() => handleCloseConfirm()}>
                  Kembali
               </Button>
               <Button disabled={loading} onClick={(e) => handleSubmit(e)} className="rounded-pill py-2 w-50" variant="success">
                  {loading ? <i class="ph-spinner spinner text-light"></i> : 'Kirim'}
               </Button>
            </div>
         </Offcanvas.Body>
      </Offcanvas>
   </Form>
  );
}